import { authHeader, getApiUrl, getTokenFromCookie, handleError, handleResponse } from '@/_helpers/http';
import {IMedia, IMediaDownloadCriteria, IMediaEdit, IMediaSearchCriteria, IMediaWrite} from "@/_objects/IMedia";
import {ISearchResponse} from "@/_objects/ISearch";

export async function download(criteria: IMediaDownloadCriteria) {
    let qs: string = `isApproved=${criteria.isApproved}&sortBy=${criteria.sortBy}`;
    qs += `&search=${encodeURIComponent(criteria.search || '')}`;
    qs += `&search2=${encodeURIComponent(criteria.search2 || '')}`;
    qs += `&token=${getTokenFromCookie()}`;
    const url = `${await getApiUrl()}/media/download?${qs}`;
    location.href = url;
}

export async function search(criteria: IMediaSearchCriteria): Promise<ISearchResponse<IMedia>> {

    const params: RequestInit = {
        method: 'GET',
        headers: authHeader(),
    };
    let qs: string = `limit=${criteria.limit}&skip=${criteria.skip}&isApproved=${criteria.isApproved}&sortBy=${criteria.sortBy}`;
    qs += `&search=${encodeURIComponent(criteria.search || '')}`;
    qs += `&search2=${encodeURIComponent(criteria.search2 || '')}`;

    return fetch(`${await getApiUrl()}/media/search?${qs}`, params)
        .then(handleResponse)
        .catch(handleError);
}


export async function updateApproveWithComments(mediaId: string, isApproved: boolean, comment?: string): Promise<IMedia> {
    const requestOptions: RequestInit = {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...authHeader() },
        body: JSON.stringify({ isApproved, comment }),
    };

    return fetch(`${await getApiUrl()}/media/${mediaId}/approved`, requestOptions)
        .then(handleResponse)
        .catch(handleError);
}

export async function create(media: IMediaWrite): Promise<IMedia> {
    const requestOptions: RequestInit = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...authHeader() },
        body: JSON.stringify(media),
    };

    return fetch(`${await getApiUrl()}/media/`, requestOptions)
        .then(handleResponse)
        .catch(handleError);
}

export async function update(mediaId: string, media: IMediaEdit): Promise<IMedia> {
    const requestOptions: RequestInit = {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...authHeader() },
        body: JSON.stringify(media),
    };

    return fetch(`${await getApiUrl()}/media/${mediaId}`, requestOptions)
        .then(handleResponse)
        .catch(handleError);
}
